import { normalizeProjectRef } from '../lib/project-ref';
import type { PmDeadlineFilters, PmProjectFilters, PmTaskFilters, PmTimelineParams } from './types';

export const pmKeys = {
  all: ['pm'] as const,
  me: ['pm', 'me'] as const,
  /**
   * v1.3 GET /me/settings. Deliberately outside the ['pm'] tree: data invalidations never refetch it — after the first
   * load the client owns its view settings (written optimistically, saved with a debounced PATCH; staleTime Infinity).
   */
  settings: ['pm-settings', 'me'] as const,
  lookups: ['pm', 'lookups'] as const,
  people: (includeInactive: boolean) => ['pm', 'people', { includeInactive }] as const,
  projects: ['pm', 'projects'] as const,
  projectList: (f: PmProjectFilters) => ['pm', 'projects', 'list', f] as const,
  /** v1.3: one key per URL ref (code upper-cased, or the numeric id); a coded project is cached under both (`writeProjectToCache`). */
  project: (ref: string) => ['pm', 'projects', 'detail', normalizeProjectRef(ref)] as const,
  activity: (projectId: number) => ['pm', 'projects', 'activity', projectId] as const,
  notes: (projectId: number) => ['pm', 'projects', 'notes', projectId] as const,
  /** v1.2: one phase's notes (GET notes?phaseId=); under the project's notes prefix so every project write invalidates it. */
  phaseNotes: (projectId: number, phaseId: number) => ['pm', 'projects', 'notes', projectId, 'phase', phaseId] as const,
  tasks: (f: PmTaskFilters) => ['pm', 'tasks', f] as const,
  deadlines: (f: PmDeadlineFilters) => ['pm', 'deadlines', f] as const,
  timeline: (p: PmTimelineParams) => ['pm', 'timeline', p] as const,
  /** v1.2 GET /timeline/notes (PM viewers only); under the timeline prefix so note writes invalidate it. */
  timelineNotes: (p: PmTimelineParams) => ['pm', 'timeline', 'notes', p] as const,
  admin: {
    all: ['pm', 'admin'] as const,
    access: ['pm', 'admin', 'access'] as const,
    users: ['pm', 'admin', 'users'] as const,
    people: ['pm', 'admin', 'people'] as const,
    importRuns: ['pm', 'admin', 'import-runs'] as const,
    importRun: (id: number) => ['pm', 'admin', 'import-runs', id] as const,
  },
};
